export default "__VITE_ASSET__B45sdvWC__";